import { render, staticRenderFns } from "./KCardActions.vue?vue&type=template&id=54f13e02"
import script from "./KCardActions.vue?vue&type=script&lang=js"
export * from "./KCardActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardActions})
